import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  logInSuccess,
  logInFail,
  logOutSuccess,
  logOutFail,
  signUpSuccess,
  signUpFail,
  getCurrentUserSuccess,
  getCurrentUserFail,
  getTaxInspectorsSuccess,
  getTaxInspectorsFail,
  editTaxInspectorsSuccess,
  editTaxInspectorsFail,
  addTaxInspectorsSuccess,
  addTaxInspectorsFail,
  getUsersSurveysSuccess,
  getUsersSurveysFail,
  updateSurveyStatusSuccess,
  updateSurveyStatusFail,
  forgotPasswordSuccess,
  forgotPasswordFail,
  updatePasswordSuccess,
  updatePasswordFail,
  updatePhoneAndAddressSuccess,
  updatePhoneAndAddressFail,
  getActivityLogsFail,
  getActivityLogsSuccess,
  getAdminActivityLogsSuccess,
  getAdminActivityLogsFail,
} from "../actionCreators/User";
import { doGet, doPost } from "../utils/request";
import generateToken from "../Config/firebase";

const getNewPasswordType = "GET_NEW_PASSWORD";

function* dosignUp({ obj, history }) {
  try {
    const response = yield doPost("/user/signup", obj);
    yield put(signUpSuccess(response.data));
  } catch (err) {
    const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));
    yield put(signUpFail(err.response.data.message || err.message));
    yield call(delay, 2000);
    yield put(signUpFail());
  }
}

function* doLogIn({ obj, history, redirectUrl }) {
  try {
    const response = yield doPost("/user/login", obj);
    generateToken().then((token) => {
      localStorage.setItem("fmc-token", token);
      const saveToken = doPost("/user/device-token", { device_token: token });
    });
    let token = response.data.token;
    let refreshToken = response.data.refreshToken;
    if (response.data.type === getNewPasswordType) {
      token = JSON.stringify(token);
      refreshToken = JSON.stringify(refreshToken);
      localStorage.setItem("access-token", token);
      localStorage.setItem("refresh-token", refreshToken);
      history.push("/update-password");
      yield put(logInFail(response.data.message));
      return;
    }
    yield put(logInSuccess(response.data));
    token = JSON.stringify(token);
    refreshToken = JSON.stringify(refreshToken);
    localStorage.setItem("access-token", token);
    localStorage.setItem("refresh-token", refreshToken);
  } catch (err) {
    yield put(logInFail(err.response.data.message));
  }
}
function* doUpdatePassword({ obj, history, redirectUrl }) {
  try {
    yield doPost("/user/changePassword", obj);
    yield put(updatePasswordSuccess());
    yield call(doLogOut);
  } catch (err) {
    yield put(updatePasswordFail(err.response.data.message));
  }
}
function* doUpdatePhoneAddress({ obj, history, redirectUrl }) {
  try {
    const response = yield doPost("/user/update", obj);
    yield put(updatePhoneAndAddressSuccess(response.data));
    yield call(getCurrentUser);
  } catch (err) {
    yield put(updatePhoneAndAddressFail(err.response.data.message));
  }
}
function* doForgotPassword({ obj, history, redirectUrl }) {
  try {
    obj = { ...obj, appType: "Dashboard" };
    const response = yield doPost("/user/forgotPassword", obj);
    yield put(forgotPasswordSuccess(response.data));

    let token = response.data.token;
    token = JSON.stringify(token);
  } catch (err) {
    yield put(forgotPasswordFail(err.response.data.message));
  }
}

function* doLogOut() {
  try {
    let token = localStorage.getItem("fmc-token");
    let refreshToken = JSON.parse(localStorage.getItem("refresh-token"));
    yield doPost("/user/logout", { token: token, refreshToken });
    yield put(logOutSuccess());
    localStorage.removeItem("fmc-token");
    localStorage.removeItem("access-token");
    localStorage.removeItem("refresh-token");
    window.location =  "/login";
  } catch (err) {
    yield put(logOutFail(err.response.data.message));
  }
}

function* getCurrentUser() {
  try {
    const response = yield doGet("/user/me");
    yield put(getCurrentUserSuccess(response.data));
  } catch (err) {
    yield put(getCurrentUserFail(err.message));
  }
}

function* getUsers({ obj }) {
  try {
    const response = yield doGet(
      `/user/all?page=${obj.page}&pageSize=${obj.pageSize}`
    );

    yield put(getTaxInspectorsSuccess(response.data));
  } catch (err) {
    yield put(getTaxInspectorsFail(err.response.data.message || err.message));
    yield put(getTaxInspectorsFail());
  }
}

function* addUsers({ obj }) {
  try {
    const response = yield doPost(`/user/create`, obj);

    yield put(addTaxInspectorsSuccess(response.data));
  } catch (err) {
    yield put(addTaxInspectorsFail(err.response.data.message || err.message));
  }
}

function* editUsers({ obj }) {
  try {
    const response = yield doPost(`/user/edit`, obj);

    yield put(editTaxInspectorsSuccess(response.data));
  } catch (err) {
    yield put(editTaxInspectorsFail(err.response.data.message || err.message));
  }
}

function* getUsersSurveys({ obj }) {
  try {
    const response = yield doGet(
      `/user/sruveys?page=${obj.page}&pageSize=${obj.pageSize}`
    );

    yield put(getUsersSurveysSuccess(response.data));
  } catch (err) {
    yield put(getUsersSurveysFail(err.response.data.message || err.message));
    yield put(getUsersSurveysFail());
  }
}

function* updateSurveyStatus({ obj }) {
  try {
    const response = yield doPost(`/user/surveyStatus`, obj);

    yield put(updateSurveyStatusSuccess(response.data));
  } catch (err) {
    yield put(updateSurveyStatusFail(err.response.data.message || err.message));
    yield put(updateSurveyStatusFail());
  }
}
function* getActivityLogs({ obj }) {
  try {
    let response;
    if (obj.eto_id) {
      response = yield doGet(
        `/admin-logs?eto=${obj.eto_id}&pageSize=${obj.pageSize}&page=${obj.page}&property_no=${obj?.pin}&filter=${obj.filter}`,
        obj
      );
    } else if (obj.inspector_id) {
      response = yield doGet(
        `/admin-logs?taxInspector=${obj.inspector_id}&pageSize=${obj.pageSize}&page=${obj.page}&property_no=${obj?.pin}&filter=${obj.filter}`,
        obj
      );
    } else {
      yield put(getActivityLogsFail("Invaild Params"));
      yield put(getActivityLogsFail());
    }

    yield put(getActivityLogsSuccess(response.data));
  } catch (err) {
    yield put(getActivityLogsFail(err.response.data.message || err.message));
    yield put(getActivityLogsFail());
  }
}
function* getAdminActivityLogs({ obj }) {
  try {
    const response = yield doGet(
      `/admin/logs?pageSize=${obj.pageSize}&page=${obj.page}&filter=${obj.filter}`
    );

    yield put(getAdminActivityLogsSuccess(response.data));
  } catch (err) {
    yield put(
      getAdminActivityLogsFail(err.response.data.message || err.message)
    );
    yield put(getAdminActivityLogsFail());
  }
}
export default function* watcher() {
  yield all([
    takeLatest("SIGNUP", dosignUp),
    takeLatest("LOGIN", doLogIn),
    takeLatest("UPDATE_PASSWORD", doUpdatePassword),
    takeLatest("UPDATE_PHONE_ADDRESS", doUpdatePhoneAddress),
    takeLatest("FORGOT_PASSWORD", doForgotPassword),
    takeLatest("LOGOUT", doLogOut),
    takeLatest("GET_CURRENT_USER", getCurrentUser),
    takeLatest("GET_TAX_INSPECTORS", getUsers),
    takeLatest("ADD_TAX_INSPECTORS", addUsers),
    takeLatest("EDIT_TAX_INSPECTORS", editUsers),
    takeLatest("GET_USERS_SURVEYS", getUsersSurveys),
    takeLatest("UPDATE_SURVEY_STATUS", updateSurveyStatus),
    takeLatest("GET_ACTIVITY_LOGS", getActivityLogs),
    takeLatest("GET_ADMIN_ACTIVITY_LOGS", getAdminActivityLogs),
  ]);
}
